const onboardingStages = [
    "demographics",
    "documents"
  ];
  
const getPracticeOnboardingStages = () => {
  var stages = onboardingStages;

  return stages;
}

export default getPracticeOnboardingStages;
